import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { PhoneCampaignDetail } from "@/components/phone-banking/PhoneCampaignDetail";
import { PhoneCampaignResults } from "@/components/phone-banking/PhoneCampaignResults";
import { usePhoneCampaign } from "@/hooks/use-phone-campaigns";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute(
	"/_app/_/phone-banking/$campaignId/",
)({
	component: PhoneBankingDetailPage,
});

type Tab = "overview" | "results";

function PhoneBankingDetailPage() {
	const { campaignId: campaignIdStr } = Route.useParams();
	const phoneCampaignId = Number(campaignIdStr);
	const [activeTab, setActiveTab] = useState<Tab>("overview");

	const session = useSession();
	const campaignId = session?.campaign?.id ?? 0;
	const { data: pc } = usePhoneCampaign(campaignId, phoneCampaignId);

	return (
		<div className="p-6">
			{/* Tab navigation */}
			<div className="mb-6 border-b">
				<nav className="flex gap-6">
					<button
						type="button"
						onClick={() => setActiveTab("overview")}
						className={`pb-3 text-sm font-medium border-b-2 transition-colors ${
							activeTab === "overview"
								? "border-primary text-primary"
								: "border-transparent text-muted-foreground hover:text-foreground"
						}`}
					>
						Overview
					</button>
					<button
						type="button"
						onClick={() => setActiveTab("results")}
						className={`pb-3 text-sm font-medium border-b-2 transition-colors ${
							activeTab === "results"
								? "border-primary text-primary"
								: "border-transparent text-muted-foreground hover:text-foreground"
						}`}
					>
						Results
						{pc?.status === "active" && (
							<span className="ml-1.5 inline-block h-2 w-2 rounded-full bg-green-500" />
						)}
					</button>
				</nav>
			</div>

			{/* Tab content */}
			{activeTab === "overview" ? (
				<PhoneCampaignDetail phoneCampaignId={phoneCampaignId} />
			) : (
				<PhoneCampaignResults
					phoneCampaignId={phoneCampaignId}
					campaignStatus={pc?.status ?? "draft"}
				/>
			)}
		</div>
	)
}
